import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const PaycometCreditCardPaymentContainer = styled.div`
  margin: ${primitive.$spacing2} 0;
  width: 100%;
`;
